import * as moment from 'moment';
import { cloneDeep } from 'lodash-es';
import { addresses } from './address.mock';
import {
  ApiReorderDetailsItemResponse,
  ConsentStatusValue,
  DetailedOrderStatusName,
  OneDotOrderStatus,
  OrderStatusApiOrderResponse,
  PwpApiOrderResponse,
  PwpOrderStatus,
  YesOrNo,
} from 'src/app/core/models';
import { primaryInsurance, secondaryInsurance } from './insurance.mock';
import produce from 'immer';

const today = moment().startOf('day');

const fiveDotStatusTemplate = [
  {
    statusName: DetailedOrderStatusName.Documentation,
    statusFlag: YesOrNo.Y,
    internalDetail: 'The documentation for this order is on file',
    externalDetail: 'We have the documentation on file for this order',
  },
  {
    statusName: DetailedOrderStatusName.PreAuth,
    statusFlag: YesOrNo.Y,
    internalDetail: '',
    externalDetail: '',
  },
  {
    statusName: DetailedOrderStatusName.Insurance,
    statusFlag: YesOrNo.Y,
    internalDetail: 'The patients Primary & Secondary insurance is active for this order',
    externalDetail: 'Your insurance is active for this order',
  },
  {
    statusName: DetailedOrderStatusName.Consent,
    statusFlag: YesOrNo.Y,
    internalDetail: 'Have Consent',
    externalDetail: 'Your authorization to ship this order is on file',
  },
  {
    statusName: DetailedOrderStatusName.Shipment,
    statusFlag: YesOrNo.Y,
    internalDetail: 'Delivered on 2022-08-17',
    externalDetail: 'Delivered on 2022-08-17',
  },
];

// Mock data to use for all order endpoints
export const orders = [
  {
    id: 1001,
    reorderCardId: 9991,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.Shipped,
    status: PwpOrderStatus.Shipped,
    targetedShipDate: today.clone().subtract(1, 'day').format(),
    deliveryDate: undefined,
    trackingNumber: undefined,
    trackingNumberUrl: undefined,
    shipmentTypeId: 60,
    shipmentTypeName: 'Pump and/or CGM',
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    mockDetails: {
      orderItemDetails: [
        {
          itemId: 1,
          itemDescription: 'MCR-DEXCOM G6 SENSOR (3 PACK) STS-OM-003',
          categoryName: 'CGM Sensor',
          quantity: 1,
          totalQuantity: 1,
        },
      ],
      primaryInsurance,
      secondaryInsurance,
    },
    fiveDotStatus: cloneDeep(fiveDotStatusTemplate),
  },
  {
    id: 1002,
    reorderCardId: 9992,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.Delivered,
    status: PwpOrderStatus.Delivered,
    targetedShipDate: today.clone().subtract(10, 'days').format(),
    deliveryDate: today.clone().subtract(5, 'days').format(),
    trackingNumber: '1Z6E918FYW01329641',
    trackingNumberUrl: 'https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=9205590100069874069927',
    shipmentTypeId: 60,
    shipmentTypeName: 'Pump and/or CGM',
    shippingAddressId: addresses[1].addressId,
    shippingAddress1: addresses[1].line1,
    shippingAddress2: addresses[1].line2,
    shippingCity: addresses[1].city,
    shippingState: addresses[1].state,
    shippingZip: addresses[1].zip,
    mailClass: 'A',
    mockDetails: {
      orderItemDetails: [
        {
          itemId: 46879,
          categoryName: 'Insulin Pump Supplies',
          itemDescription: 'T:Lock Autosoft 90 Grey 9mm 23"',
          quantity: 30,
          totalQuantity: 30,
        },
        {
          itemId: 46897,
          categoryName: 'Insulin Pump Supplies',
          itemDescription: 'T:Lock T:Slim 3mL Cartridge 1002541',
          quantity: 30,
          totalQuantity: 30,
        },
      ],
      primaryInsurance: {
        insuranceId: 73886,
        insuranceName: 'HUMANA MCR GOLD PLUS HMO',
        nameOfInsured: 'AMANDA YAGER',
        relationshipToInsured: 'Self',
        insuranceNo: 'H44917613',
        insuranceGroupNo: 'Y0637001',
      },
    },
    fiveDotStatus: cloneDeep(fiveDotStatusTemplate),
  },
  {
    id: 1003,
    reorderCardId: 9993,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.Delivered,
    status: PwpOrderStatus.Delivered,
    targetedShipDate: today.clone().subtract(2, 'months').format(),
    trackingNumber: '1Z6E918FYW01329641',
    trackingNumberUrl: 'https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=1Z6E918FYW01329641',
    shipmentTypeId: 60,
    shipmentTypeName: 'Pump and/or CGM',
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    mockDetails: {
      orderItemDetails: [
        {
          itemId: 1,
          itemDescription: 'MCR-DEXCOM G6 SENSOR (3 PACK) STS-OM-003',
          categoryName: 'CGM Sensor',
          quantity: 1,
          totalQuantity: 1,
        },
      ],
    },
    fiveDotStatus: cloneDeep(fiveDotStatusTemplate),
  },
  {
    id: 1004,
    reorderCardId: 9994,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.TooEarlyToAuthorize,
    status: PwpOrderStatus.OrderPending,
    targetedShipDate: today.clone().add(40, 'days').format(),
    consentDate: null,
    estimatedEarliestConsentDate: today.clone().add(37, 'days').format(),
    //estimatedEarliestConsentDate: today.clone().add(2, 'years').add(37, 'days').format(),
    deliveryDate: undefined,
    trackingNumber: undefined,
    trackingNumberUrl: undefined,
    shipmentTypeId: 60,
    shipmentTypeName: 'Pump and/or CGM',
    mockDetails: {
      orderItemDetails: [
        {
          itemId: 1,
          itemDescription: 'MCR-DEXCOM G6 SENSOR (3 PACK) STS-OM-003',
          categoryName: 'CGM Sensor',
          quantity: 1,
          totalQuantity: 1,
        },
      ],
    },
    fiveDotStatus: cloneDeep(fiveDotStatusTemplate),
  },
];

export const reorderDt = today.clone().add(10, 'days').format();

export const reorders = [
  {
    id: 1011,
    reorderCardId: 1011,
    isShipment: false,
    oneDotStatus: OneDotOrderStatus.ReadyToAuthorize,
    status: PwpOrderStatus.Authorize,
    items: [
      {
        itemId: 1,
        uiId: 'uuid-1',
        itemDescription: 'item 1',
        category: 'category 1',
        quantity: 10,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 2,
        uiId: 'uuid-2',
        itemDescription: 'item 2',
        category: 'category 2',
        quantity: 20,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
    ],
    //reorderServiceDate: '2021-12-26T18:34:00Z',
    reorderServiceDate: reorderDt,
    shipmentType: 'Pump and/or CGM',
    shipmentTypeId: 60,
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    fiveDotStatus: [],
  },
  {
    id: 1012,
    reorderCardId: 1012,
    isShipment: false,
    oneDotStatus: OneDotOrderStatus.ReadyToAuthorize,
    status: PwpOrderStatus.Authorize,
    items: [
      {
        itemId: 3,
        uiId: 'uuid-3',
        itemDescription: 'Sets/Reservoirs item',
        category: 'category 3',
        quantity: 30,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        //shipmentTypeId: 50,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 4,
        uiId: 'uuid-4',
        itemDescription: 'Sensors item',
        category: 'category 10',
        quantity: 30,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'K0553',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 5,
        uiId: 'uuid-5',
        itemDescription: 'Testing Supplies item',
        category: 'category 4',
        quantity: 40,
        shipItem: YesOrNo.Y,
        chargeType: 'Cash Sale',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4253',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 5,
        uiId: 'uuid-6',
        itemDescription: 'No Charge item',
        category: 'category 4',
        quantity: 1,
        shipItem: YesOrNo.Y,
        chargeType: 'No Charge',
        shipmentTypeId: 60,
        dupItem: YesOrNo.Y,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 7,
        uiId: 'uuid-7',
        itemDescription: 'No ship item',
        category: 'category 5',
        quantity: 50,
        shipItem: YesOrNo.N,
        shipmentTypeId: 60,
        chargeType: 'Insurance',
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 8,
        uiId: 'uuid-8',
        itemDescription: 'Sets/Reservoirs Missing docs item',
        category: 'category 5',
        quantity: 50,
        shipItem: YesOrNo.Y,
        shipmentTypeId: 60,
        chargeType: 'Insurance',
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'NONE',
        isDocRequired: YesOrNo.Y,
      },
    ] as ApiReorderDetailsItemResponse[],
    //reorderServiceDate: '2022-03-26T18:34:00Z',
    reorderServiceDate: reorderDt,
    shipmentType: 'Pump and/or CGM',
    shipmentTypeId: 60,
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    fiveDotStatus: [],
  },
  // Shipment Needing Reconsent
  {
    id: 1005,
    reorderCardId: 9995,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.ReadyToAuthorize,
    status: PwpOrderStatus.ReadyToShip,
    items: [
      {
        itemId: 1,
        uiId: 'uuid-1',
        itemDescription: 'item 1',
        category: 'category 1',
        quantity: 10,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 2,
        uiId: 'uuid-2',
        itemDescription: 'item 2',
        category: 'category 2',
        quantity: 20,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
    ],
    reorderServiceDate: reorderDt,
    shipmentType: 'Pump and/or CGM',
    shipmentTypeId: 60,
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    fiveDotStatus: produce(fiveDotStatusTemplate, (draft) => {
      const consentStatus = draft.find((s) => s.statusName === DetailedOrderStatusName.Consent);
      consentStatus!.internalDetail = ConsentStatusValue.NeedsReconsent;
      consentStatus!.externalDetail = 'Authorization to ship your order is needed';
      consentStatus!.statusFlag = YesOrNo.N;
    }),
  },
  // Shipment Needing Consent
  {
    id: 1006,
    reorderCardId: 9996,
    isShipment: true,
    oneDotStatus: OneDotOrderStatus.ReadyToAuthorize,
    status: PwpOrderStatus.ReadyToShip,
    items: [
      {
        itemId: 1,
        uiId: 'uuid-1',
        itemDescription: 'item 1',
        category: 'category 1',
        quantity: 10,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
      {
        itemId: 2,
        uiId: 'uuid-2',
        itemDescription: 'item 2',
        category: 'category 2',
        quantity: 20,
        shipItem: YesOrNo.Y,
        chargeType: 'Insurance',
        shipmentTypeId: 60,
        dupItem: YesOrNo.N,
        hcpcsCode: 'A4230',
        validShippingQuantity: 10,
        docCoverage: 'PWO',
        isDocRequired: YesOrNo.Y,
      },
    ],
    reorderServiceDate: reorderDt,
    shipmentType: 'Pump and/or CGM',
    shipmentTypeId: 60,
    shippingAddressId: addresses[0].addressId,
    shippingAddress1: addresses[0].line1,
    shippingAddress2: addresses[0].line2,
    shippingCity: addresses[0].city,
    shippingState: addresses[0].state,
    shippingZip: addresses[0].zip,
    mailClass: 'A',
    fiveDotStatus: produce(fiveDotStatusTemplate, (draft) => {
      const consentStatus = draft.find((s) => s.statusName === DetailedOrderStatusName.Consent);
      consentStatus!.internalDetail = 'Needs Consent';
      consentStatus!.externalDetail = 'Needs Consent';
      consentStatus!.statusFlag = YesOrNo.N;
    }),
  },
];

export const getOrderStatusOrders = (): OrderStatusApiOrderResponse[] => {
  return [
    ...orders.map((o) => {
      return {
        cardReferenceNumber: o.isShipment ? undefined : o.id,
        shipmentReferenceNumber: o.isShipment ? o.id : undefined,
        oneDotStatus: o.oneDotStatus,
        targetedShipDate: o.targetedShipDate,
        deliveryDate: o.deliveryDate,
        consentDate: o.consentDate,
        estimatedEarliestConsentDate: o.estimatedEarliestConsentDate,
        trackingNumber: o.trackingNumber,
        trackingNumberUrl: o.trackingNumberUrl,
        shipmentTypeId: o.shipmentTypeId,
        shipmentTypeName: o.shipmentTypeName,
        shippingAddressId: o.shippingAddressId,
        shippingAddress1: o.shippingAddress1,
        shippingAddress2: o.shippingAddress2,
        shippingCity: o.shippingCity,
        shippingZip: o.shippingZip,
        shippingState: o.shippingState,
        mailClass: o.mailClass,
        fiveDotStatus: o.fiveDotStatus,
        isShipment: o.isShipment,
      };
    }),
    ...reorders
      .filter((ro) => ro.isShipment)
      .map((ro) => {
        return {
          cardReferenceNumber: ro.isShipment ? undefined : ro.id,
          shipmentReferenceNumber: ro.isShipment ? ro.id : undefined,
          oneDotStatus: ro.oneDotStatus,
          targetedShipDate: ro.reorderServiceDate,
          deliveryDate: undefined,
          trackingNumber: undefined,
          trackingNumberUrl: undefined,
          shipmentTypeId: ro.shipmentTypeId,
          shipmentTypeName: ro.shipmentType,
          shippingAddressId: ro.shippingAddressId,
          shippingAddress1: ro.shippingAddress1,
          shippingAddress2: ro.shippingAddress2,
          shippingCity: ro.shippingCity,
          shippingZip: ro.shippingZip,
          shippingState: ro.shippingState,
          mailClass: ro.mailClass,
          fiveDotStatus: ro.fiveDotStatus,
          isShipment: true,
        };
      }),
  ];
};

export const getPwpOrders = (): PwpApiOrderResponse[] => {
  return [
    ...orders.map((o) => {
      const { mockDetails, id, estimatedEarliestConsentDate, ...rest } = o;
      return { ...rest, referenceNumber: id, consentDate: estimatedEarliestConsentDate };
    }),
    ...reorders
      .filter((ro) => !ro.isShipment)
      .map((ro) => {
        return {
          referenceNumber: ro.id,
          reorderCardId: ro.reorderCardId,
          status: ro.status,
          targetedShipDate: ro.reorderServiceDate,
          deliveryDate: undefined,
          trackingNumber: undefined,
          trackingNumberUrl: undefined,
          shipmentTypeId: ro.shipmentTypeId,
          shipmentTypeName: ro.shipmentType,
          shippingAddressId: ro.shippingAddressId,
          shippingAddress1: ro.shippingAddress1,
          shippingAddress2: ro.shippingAddress2,
          shippingCity: ro.shippingCity,
          shippingZip: ro.shippingZip,
          shippingState: ro.shippingState,
          mailClass: ro.mailClass,
          isShipment: false,
        };
      }),
  ];
};
